import { render } from "./Credentials.vue?vue&type=template&id=f35d6154"
import script from "./Credentials.vue?vue&type=script&lang=js"
export * from "./Credentials.vue?vue&type=script&lang=js"

import "./Credentials.vue?vue&type=style&index=0&id=f35d6154&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__